module.exports = __webpack_public_path__ + "static/img/200138.9aa72c2d.png";